import api from './APIInterceptor'

export default class AccountService {
  static permissions() {
    return api.get('/me/permissions')
  }

  static currentUserDetails() {
    return api.get('/me')
  }

  static updateCurrentUser(values) {
    return api.patch('/me', values)
  }

  static changePassword(values) {
    return api.patch('/me/password', values)
  }

  static currentUserCoworkers() {
    return api.get('/me/company/users')
  }

  static async uploadUserAvatar(avatar) {
    const formData = new FormData()
    formData.append('avatar', avatar)
    return api.post('/me/avatar', formData)
  }

  static async uploadEmployeeAvatar({ id, file }) {
    const formData = new FormData()
    formData.append('avatar', file)
    return api.post(`/me/company/users/${id}/avatar`, formData)
  }

  static sendContactForm(values) {
    return api.post('/contact', values)
  }

  static getPublicApiTokens() {
    return api.get('/me/public-api-tokens')
  }

  static createPublicApiToken(name) {
    return api.post('/me/public-api-tokens', { name })
  }

  static updatePublicApiToken(id, name) {
    return api.patch(`/me/public-api-tokens/${id}`, { name })
  }

  static deletePublicApiToken(id) {
    return api.delete(`/me/public-api-tokens/${id}`)
  }

  static getCompanyWebhook() {
    return api.get('/me/company/webhook')
  }

  static updateCompanyWebhook(values) {
    return api.post('/me/company/webhook', values)
  }

  static rotateCompanyWebhookSecret() {
    return api.post('/me/company/webhook/rotate-secret')
  }
}
